/**
 * ChannelsFilter Component
 *
 * Multi-select filter for communication channels.
 * Uses OR logic only - records matching ANY selected channel are included.
 * (AND logic not supported as records have single channel values)
 */

import { MessageSquare } from 'lucide-react';
import { FilterDropdown } from './FilterDropdown';
import type { BusinessContextFilterProps } from '../types/filter.types';

export function ChannelsFilter({
  value,
  onChange,
  options,
  disabled = false,
  className,
}: BusinessContextFilterProps) {
  // Handle values change - always use OR logic for single-value fields
  const handleValuesChange = (values: string[] | undefined) => {
    if (!values || values.length === 0) {
      onChange(undefined);
    } else {
      onChange({
        values,
        logic: 'or',
      });
    }
  };

  return (
    <FilterDropdown
      value={value?.values}
      onChange={handleValuesChange}
      options={options}
      icon={<MessageSquare className="h-4 w-4" />}
      emptyLabel="All Channels"
      pluralNoun="channels"
      helperText="Select channels (matches any)"
      disabled={disabled}
      className={className}
    />
  );
}
